function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".categories_svg__st0{fill:none;stroke:currentColor;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "categories_svg__st0",
  cx: 5.85,
  cy: 5.85,
  r: 5.703
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "categories_svg__st0",
  d: "M5.021 3.742h3.362M5.021 5.85h3.362M5.021 7.958h3.362M3.317 3.742h.748M3.317 5.85h.748m-.748 2.108h.748"
});

function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "categories_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.7 11.7",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCategories;